module.exports = __webpack_public_path__ + "img/Tangle-Ridge.64c07a90.jpeg";